import { FormSpinners } from "../../util/spinner/spinner-handler";
import { brandsFilterForm } from "./brands-filter-form";
import { BrandsFilterListener } from "./brands-filter-listener";

export class BrandsFilterFormSetup {
    public static init(root: HTMLElement): void {
        if (!(root instanceof HTMLFormElement)) return;
        if (!root.classList.contains("brand-search-form")) return;
        const submitForm = (form: HTMLFormElement): void => {
            if (typeof form.requestSubmit === "function") {
                form.requestSubmit();
                return;
            }

            FormSpinners.showPageSpinner();
            form.submit();
        };

        if (root.dataset.brandFilterSpinnerBound !== "1") {
            root.dataset.brandFilterSpinnerBound = "1";
            BrandsFilterListener.bindSubmit(root, (event) => {
                if (event.defaultPrevented) {
                    return;
                }

                FormSpinners.showPageSpinner();
            });
        }

        const filterInputs = brandsFilterForm.getFilterInputs(root);
        filterInputs.forEach((input) => {
            if (input.type === "radio" && input.name === "priority") {
                const label = brandsFilterForm.getPriorityFilterLabel(input);
                if (label instanceof HTMLElement) {
                    BrandsFilterListener.bindMouseDown(label, () => {
                        input.dataset.wasChecked = input.checked ? "1" : "0";
                    });
                }

                BrandsFilterListener.bindClick(input, (event) => {
                    const wasChecked = input.dataset.wasChecked === "1";
                    delete input.dataset.wasChecked;

                    if (!wasChecked) {
                        return;
                    }

                    event.preventDefault();
                    input.checked = false;

                    const form = input.form;
                    if (!(form instanceof HTMLFormElement)) {
                        return;
                    }

                    submitForm(form);
                });
            }

            BrandsFilterListener.bindChange(input, () => {
                const form = input.form;
                if (!(form instanceof HTMLFormElement)) {
                    return;
                }

                submitForm(form);
            });
        });
    }
}
